import { LegalPageRenderer } from "../components/legal/LegalPageRenderer";
import { PRIVACY } from "../data/legal";

export function PrivacyPage() {
  return <LegalPageRenderer content={PRIVACY} />;
}
